import { useMutation } from '@tanstack/react-query';
import { useCallback } from 'react';
import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';
import { INVOICE_TYPE } from '../constants/invoice.enums';
import InvoiceService from '../services/invoice.service';

export const useDownloadInvoice = (type: INVOICE_TYPE) => {
  const { t } = useTranslation();

  const { mutate: downloadInvoice, isLoading: isDownloading } = useMutation(
    async (code: string) => {
      const blob = await InvoiceService.downloadInvoice(type, code);
      const url = window.URL.createObjectURL(new Blob([blob]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `${type}-${code}.pdf`);
      link.click();
      window.URL.revokeObjectURL(url);
    },
    {
      onError: () => {
        toast.error(t('common:errors.downloadError'));
      },
    },
  );

  const handleDownload = useCallback(
    (code: string) => {
      downloadInvoice(code);
    },
    [downloadInvoice],
  );

  return {
    downloadInvoice: handleDownload,
    isDownloading,
  };
};
